import React, { useEffect } from "react";

export default function LegacyProveRedirect() {
  useEffect(() => {
    const url = new URL(window.location.href);
    url.searchParams.set("audit", "onto-detail");
    url.searchParams.set("tab", "ai");
    window.history.replaceState({}, "", url.toString());
    window.dispatchEvent(new PopStateEvent("popstate"));
  }, []);

  return (
    <div style={{ padding: 24, color: "var(--audit-text-muted)", fontSize: 13 }}>
      기존 온톨로지 화면을 PROVE 세번분류로 전환하고 있습니다…
    </div>
  );
}
